import * as amplitude from '@amplitude/analytics-browser';
import { world, canada, usa, deploymentsGlobal, deploymentsCanada, deploymentsUs } from './amplitude_environments';
/**
 * Construct the Amplitude configuration object for an environment.
 *
 * @param product - The FanDuel product, e.g. 'sportsbook', 'dfs'.
 * @param environment - The FanDuel environment, e.g. 'prod', 'test', 'dev'.
 * @param experimentDeployment - Allows selection of a different experiment environment to the main environment.
 * @param debug - Enable verbose console logging from Amplitude.
 *
 * @returns An object that can be used to configure the Amplitude SDK.
 */
export const getConfig = (product, environment, country, experimentDeployment, debug) => {
  var _countryConfig$produc;
  // For Amplitude purposes, anything that's not prod is test.
  const amplitudeEnvironment = environment === 'prod' ? 'prod' : 'test';
  const countryConfig = country === 'usa' ? {
    ...world,
    ...usa
  } : {
    ...world,
    ...canada
  };
  const countryDeployments = country === 'usa' ? {
    ...deploymentsGlobal,
    ...deploymentsUs
  } : {
    ...deploymentsGlobal,
    ...deploymentsCanada
  };
  let experimentKey = (_countryConfig$produc = countryConfig[product]) === null || _countryConfig$produc === void 0 || (_countryConfig$produc = _countryConfig$produc[amplitudeEnvironment]) === null || _countryConfig$produc === void 0 ? void 0 : _countryConfig$produc.experiment;
  if (experimentDeployment) {
    var _countryDeployments$p;
    experimentKey = ((_countryDeployments$p = countryDeployments[product]) === null || _countryDeployments$p === void 0 || (_countryDeployments$p = _countryDeployments$p[experimentDeployment]) === null || _countryDeployments$p === void 0 ? void 0 : _countryDeployments$p[amplitudeEnvironment]) || experimentKey;
  }
  const amplitudeOptions = {
    defaultTracking: {
      attribution: {
        resetSessionOnNewCampaign: true,
        excludeReferrers: ['dummy.value']
      },
      pageViews: false,
      sessions: false,
      formInteractions: false,
      fileDownloads: false
    },
    minIdLength: 1,
    identityStorage: 'localStorage'
  };
  const result = {
    apiKey: countryConfig[product][amplitudeEnvironment].analytics,
    amplitudeOptions,
    experimentKey,
    experimentOptions: {
      automaticExposureTracking: false,
      // We handle this in the main interface.
      automaticFetchOnAmplitudeIdentityChange: true
    }
  };
  if (typeof debug === 'undefined') {
    debug = environment === 'dev';
  }
  if (debug) {
    result.amplitudeOptions.logLevel = amplitude.Types.LogLevel.Debug;
    result.experimentOptions.debug = true;
  }
  return result;
};
//# sourceMappingURL=configuration.js.map